module.exports = __webpack_public_path__ + "img/prop-bush-1-right.da9715e6.png";